module.exports = __webpack_public_path__ + "img/title-bg.e23a57a1.png";